import {NgStyle} from '@angular/common';
import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {take} from 'rxjs';
import { RtSvgSpriteModule } from '../../../rt-svg-sprite/src';
import { RtImageCropperComponent } from '../rt-image-cropper/rt-image-cropper.component';

@Component({
  selector: 'rt-image-editor',
  standalone: true,
  imports: [NgStyle, RtSvgSpriteModule],
  templateUrl: './rt-image-editor.component.html',
  styleUrl: './rt-image-editor.component.scss',
})
export class RtImageEditorComponent {
  @Input() image: string;
  @Input() height = 112;
  @Input() width = 112;
  @Input() borderRadius = 50;

  @Output() formDataChanged: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() fileChanged: EventEmitter<File> = new EventEmitter<File>();

  public previewImage: string | ArrayBuffer;

  constructor(
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
  ) {}

  public fileChangeEvent(event: any): void {
    if (!event.target['files'] || !event.target['files'].length) {
      return;
    }

    const imageChangedEvent = event;

    const dialogRef = this.dialog.open(RtImageCropperComponent, {
      maxHeight: window.innerHeight - 30 + 'px',
      data: {
        imageChangedEvent,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          this.loadPreview(result);
          const formData = new FormData();
          const avatarData = result;
          if (avatarData instanceof File || avatarData === '') {
            formData.append('avatar', avatarData);
          }
          this.formDataChanged.next(formData);
          this.fileChanged.next(avatarData);
        }
      });
  }

  private loadPreview(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      this.previewImage = e.target?.result;
      this.cd.detectChanges();
    };
    reader.readAsDataURL(file);
  }
}
